'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { getTaxMessage } from '@/lib/tax';
import { TAX_TRANSLATION_KEYS } from './taxMessageKeys';
import styles from './TaxBadge.module.scss';

interface TaxBadgeProps {
  countryCode: string;
  taxAmount?: number;
  variant?: 'short' | 'detail';
  className?: string;
}

export const TaxBadge = ({
  countryCode,
  taxAmount,
  variant = 'short',
  className,
}: TaxBadgeProps) => {
  const t = useTranslations('price');
  const messageKey = getTaxMessage(countryCode, taxAmount);

  if (!messageKey) return null;

  const keys = TAX_TRANSLATION_KEYS[messageKey];
  if (!keys) return null;

  const translationKey = variant === 'detail' ? keys.detail : keys.short;

  return <span className={clsx(styles.badge, className)}>{t(translationKey)}</span>;
};
